import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TransformationSection } from './components/TransformationSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ModulesSection } from './components/ModulesSection';
import { ProductPreview } from './components/ProductPreview';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
// Declare fbq to avoid TypeScript errors
declare global {
  interface Window {
    fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    window.fbq = window.fbq || function () {
      ;
      (window.fbq.q = window.fbq.q || []).push(arguments);
    };
    window.fbq('init', '4327511617495565');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="font-sans text-brand-text-dark bg-brand-bg min-h-screen flex flex-col" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <TransformationSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <ModulesSection data-id="element-7" />
        <ProductPreview data-id="element-8" />
        <BonusesSection data-id="element-9" />
        <OfferSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}